let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdx3T")).then(() => parcelRequire('la7BD'));